import React from 'react';
import { useAuth } from '../context/AuthContext';
import { usePerfil } from '../context/PerfilContext';
import { Logo } from '../components/Logo';
import { Clock, LogOut, RefreshCw } from 'lucide-react';

/**
 * Lo que ve una cuenta sin ningún módulo activado. Las cuentas nuevas ya nacen
 * con los módulos por defecto, así que esto solo pasa si un administrador se
 * los quitó todos (o en cuentas antiguas, creadas antes de que existieran).
 */
export const CuentaPendiente: React.FC = () => {
  const { user, logout } = useAuth();
  const { perfil } = usePerfil();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 p-8 text-center">

        <div className="flex justify-center mb-6">
          <Logo size={48} />
        </div>

        <div className="w-14 h-14 mx-auto rounded-full bg-amber-50 dark:bg-amber-900/30 flex items-center justify-center mb-4">
          <Clock className="w-7 h-7 text-amber-600 dark:text-amber-400" />
        </div>

        <h1 className="text-xl font-bold text-gray-900 dark:text-white">
          Tu cuenta no tiene ningún módulo activado
        </h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
          Existe, pero ahora mismo no tiene acceso a ninguna parte de la app. En cuanto
          un administrador te dé acceso, lo verás aquí sin tener que hacer nada más.
        </p>

        {(perfil?.email || user?.email) && (
          <p className="text-xs font-mono text-gray-500 dark:text-gray-500 mt-4 px-3 py-2
                        rounded-lg bg-gray-50 dark:bg-gray-900/50 break-all">
            {perfil?.email || user?.email}
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-2 mt-6">
          <button onClick={() => window.location.reload()}
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-lg
                       bg-gray-900 dark:bg-gray-700 text-white text-sm font-semibold
                       hover:bg-gray-700 dark:hover:bg-gray-600 transition">
            <RefreshCw className="w-4 h-4" /> Volver a comprobar
          </button>
          <button onClick={() => logout()}
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-lg
                       border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300
                       text-sm font-semibold hover:bg-gray-50 dark:hover:bg-gray-700 transition">
            <LogOut className="w-4 h-4" /> Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};
